import React, { useState } from "react";
import webui from "@tinqin/tinqin-web-ui";
import ResponsiveHOC from "../../HOC/components/responsive";

const EMOTICON_CATEGORY = "Fiche produit";

//feedback implemented
function FeedbackSection(props) {
    const [vote, setVote] = useState(0);

    const vote1ClassName = vote === 1 ? "un-feedback-selected" : "";
    const vote2ClassName = vote === 2 ? "un-feedback-selected" : "";
    const vote3ClassName = vote === 3 ? "un-feedback-selected" : "";
    let thankYouMessageStyle = {
        display: "none"
    };
    //thank you messages to be positioned under each icon
    if (vote > 0) {
        let marginLeft = 190 + vote * 60;
        if (props.size === "S") {
            marginLeft -= 50;
        } else if (props.size === "XS") {
            marginLeft = 0;
        }
        thankYouMessageStyle = {
            display: "inline-block",
            marginTop: "0px",
            marginLeft: `${marginLeft}px`
        };
    }

    const dispatch = webui.getDispatchMethod();
    const clickHandler = (vote, eventAction) => {
        setVote(vote);
        if (props.config.bindTo) {
            const category = props.config?.properties?.category || EMOTICON_CATEGORY;
            const matomoTrack = {
                actionType: "triggerMatomoEvent",
                properties: {
                    category,
                    action: eventAction,
                    name: "{%currentPathUrl%}"
                }
            };
            const dispatchAction = webui.getActionByName("siren.dispatchSirenActions");
            dispatch(dispatchAction([matomoTrack], props.widgetId, props.computedBindTo));
        }
    };

    return (
        <div className="un-article-main-content un-article-bottom-wrapper">
            <div className="un-article-feedback">
                <p className="tq-paragraph">Donnez-nous votre avis</p>
                <a
                    className={"tq-hyperlink " + vote1ClassName}
                    onClick={() => clickHandler(1, "Emoticone Neutre")}
                >
                    <img src="/fonts/emoji-neutral.svg" alt="neutral emoji" />
                </a>
                <a
                    className={"tq-hyperlink " + vote2ClassName}
                    onClick={() => clickHandler(2, "Emoticone Bien")}
                >
                    <img src="/fonts/emoji-smile.svg" alt="smile emoji" />
                </a>
                <a
                    className={"tq-hyperlink " + vote3ClassName}
                    onClick={() => clickHandler(3, "Emoticone Tres bien")}
                >
                    <img src="/fonts/emoji-happy.svg" alt="happy emoji" />
                </a>
            </div>
            <div className="un-article-feedback-msg" style={thankYouMessageStyle}>
                <p>Merci d'avoir partagé votre avis !</p>
            </div>
        </div>
    );
}

export default webui.connectComponent()(ResponsiveHOC(FeedbackSection));
